var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarWorktime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Zm0,17.8A7.84,7.84,0,1,1,23.85,16v0A7.85,7.85,0,0,1,16,23.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,15.66H16.72V10.28a.84.84,0,0,0-.84-.84.83.83,0,0,0-.83.84v6.2a.84.84,0,0,0,.83.84h5.3a.85.85,0,0,0,.84-.84.84.84,0,0,0-.84-.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarWorktime);
export default __webpack_public_path__ + "static/media/toolbar-worktime.4971b3d7.svg";
export { ForwardRef as ReactComponent };